import { IdmClientContext } from "@sista/idm-client";
import { buildVazbatorClient } from "@sista/library-stasi";
import { useContext, useMemo } from "react";
export const useVazbatorClient = () => {
    const c = useContext(IdmClientContext);
    if (c == null) {
        throw new Error("ExpertsClientContext is null");
    }
    const authKeyToUse = c?.loggedAccount?.authKey;
    return useMemo(() => buildVazbatorClient(process.env.REACT_APP_VAZBATOR_ROOT, authKeyToUse), [authKeyToUse]);
};
